import React from 'react'
import { Image, Link } from '../base-ui'
import { generateUrl } from '../../utils'

function InlineNewsAd({ ad }) {
    const linkStyle =
        'display: block; border-radius: 10px; max-width: 25rem; margin: 0 auto; padding: 0.5rem; background: #ffffff; border: 1px dashed #dddddd; a { display: flex; justify-content: center; align-items: center; gap: 0.5rem;}'
    return (
        <Link
            href={generateUrl(ad, 'news')}
            style={linkStyle}
            rel={ad.nofollow ? 'nofollow' : ''}
        >
            <div style={{ minWidth: '4rem' }}>
                <Image
                    src={
                        ad.thumbnail?.file?.hash &&
                        `/api/filedb/${ad.thumbnail.file.hash}.${ad.thumbnail.file?.ext}`
                    }
                    alt="picture"
                    width={200}
                    height={170}
                    objectFit="cover"
                    layout="responsive"
                />
            </div>
            <div
                style={{
                    fontSize: '0.85rem',
                    textAlign: 'center',
                    overflow: 'hidden',
                    display: '-webkit-box',
                    WebkitLineClamp: '2',
                    WebkitBoxOrient: 'vertical',
                }}
            >
                {ad.title}
            </div>
        </Link>
    )
}

export default InlineNewsAd
